export default "__VITE_ASSET__BsV2Xu_k__"